import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/administrators/")({
  beforeLoad: () => {
    throw redirect({ to: "/users" });
  },
});
